var globalIsUsingStaticRendering = false;
export function enableStaticRendering(enable) {
    globalIsUsingStaticRendering = enable;
}
export function isUsingStaticRendering() {
    return globalIsUsingStaticRendering;
}
//# sourceMappingURL=staticRendering.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mobx-react-lite/es/staticRendering.js
// module id = 414
// module chunks = 118